<template lang="pug">
  #CustomerTempTextModel.CustomerModel.CustomerModel-tempTextModel.overflow-hidden(
    :class="{ 'CustomerModel-active': showModel }",
    :style="[{Zindex: Zindex}, modelCSS]"
  )
    .content-header.modal_header.rounded-bottom-1rem.pt-0(
      style="height: 50px;"
    )
      .row.align-items-center.h-100
        .col-10
          h5.mb-0 {{ editData ? '編輯訊息模板' : title }}
        .col-2
          i.iconClose(
            @click="closeModel()"
          )
    .p-3.h-100.overflow-auto(
      style="padding-top: 60px!important;"
    )
      .content.mb-3
        p.mb-2.text-gray 訊息內容：(請輸入文字)
        b-form-textarea.mb-2.border-0(
          rows="10",
          v-model="text",
          style="background: #eee;border-radius: 20px;"
        )
        small.text-muted.text-right.d-block 文字數：{{ text ? text.length : 0 }}
      .px-4
        .row.no-gutters
          .col-6.pr-2
            button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
              type="button",
              @click="closeModel()",
              style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
            ) 取消
          .col-6.pl-2
            button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
              type="button",
              @click="submitHandler()",
              style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
            ) 儲存
</template>

<script>
import IconCloseUrl from '@/assets/images/icon/icon_close.png';

export default {
  name: 'TempTextModel',
  props: {
    title: {
      type: String,
      default: ''
    },
    Zindex: {
      type: String,
      default: '15px'
    },
    modelCSS: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      text: null,
      editData: null
    };
  },
  mounted() {
    const vm = this;
    vm.$EventBus.$on('openTempTextModel', (data) => {
      if (data) {
        vm.editData = data;
      } else {
        vm.editData = null;
      }
      vm.openModel();
    });
  },
  methods: {
    initHandler() {
      if (this.editData) {
        this.text = this.editData.push_format.text;
      } else {
        this.text = null;
      }
    },
    openModel() {
      this.initHandler();
      this.showModel = true;
    },
    closeModel() {
      this.$emit('scrollToTarget');
      this.initHandler();
      this.showModel = false;
    },
    submitHandler() {
      const vm = this;

      if (!vm.text || vm.text.length === 0) {
        vm.$swal.fire({
          icon: 'error',
          title: '文字訊息內容尚未填寫'
        });
      } else {
        let apiTarget = 'createTempHandler';
          const sendData = {
            type: 'text',
            text: vm.text
          };
          let successText = '訊息模板新增成功';

        // 判斷是否是編輯
        if (vm.editData) {
          apiTarget = 'updateTempHandler';
          sendData.id = vm.editData.id;
          successText = '訊息模板編輯成功';
        }

        vm.$swal.fire({
          title: '模板儲存中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });

        vm.$store.dispatch(`sa_temp/${apiTarget}`, sendData)
          .then(() => {
            vm.$emit('changeTypeHandler');
            vm.$swal.close();
            vm.closeModel();
          });
      }
    }
  },
  beforeDestroy() {
    this.$EventBus.$off('openTempTextModel');
  }
};
</script>

<style>

</style>
